import React, { useState } from "react";
import {
  AppBar,
  Button,
  Tab,
  Tabs,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";
import SchoolIcon from "@mui/icons-material/School";
import DrawerComp from "./DrawerComp";
import Home from "./Navbar Components/Home";

import Coupons from "./Navbar Components/Coupons";
import ServicesOffered from "./Navbar Components/ServicesOffered";
import AboutUs from "./Navbar Components/EBooksNav";
import Layout from "./Courses";
import EBooks from "./EBooks";
import EBooksNav from "./Navbar Components/EBooksNav";
import CoursesNavBar from "./Navbar Components/CoursesNavbar";
import Shop from "./Shop";
import ThankYouComponent from "./ThankYouComponent";
import LiveClassComponent from "./Navbar Components/LiveClassComponent";

const PAGES = [
  "Home",
  "Courses",
  "E-Books",
  "Coupons",
  "Subscribe",
  "Shop",
  "LiveClassComponent",
];

const Header = () => {
  const [value, setValue] = useState();
  const theme = useTheme();
  console.log(theme);
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  console.log(isMatch);

  function refreshPage() {
    window.location.reload(false);
  }

  return (
    <React.Fragment>
      <Router>
        <Route
          path="/"
          render={(history) => (
            <AppBar
              sx={{
                background: "black",
                opacity: "0.77",
                height: "80px",
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
              }}
            >
              <Toolbar sx={{ position: "relative" }}>
                <SchoolIcon />
                {isMatch ? (
                  <>
                    <Typography sx={{ fontSize: "20px" }}>MentorG</Typography>
                    <DrawerComp />
                  </>
                ) : (
                  <>
                    <Typography
                      style={{ fontFamily: "s" }}
                      sx={{ fontSize: "30px" }}
                    >
                      <h3>
                        <b>MentorG </b>{" "}
                      </h3>{" "}
                    </Typography>

                    <Tabs
                      onClick={refreshPage}
                      textColor="inherit"
                      value={
                        history.location.pathname !== "/"
                          ? history.location.pathname
                          : false
                      }
                      onChange={(e, value) => setValue(value)}
                      indicatorColor="secondary"
                    >
                      <Tab
                        sx={{ fontFamily: "sans-seriff" }}
                        onClick={refreshPage}
                        label="Home"
                        value={PAGES[0]}
                        component={Link}
                        to={PAGES[0]}
                      />
                      <Tab
                        sx={{ fontFamily: "sans-seriff" }}
                        onClick={refreshPage}
                        label="Courses"
                        value={PAGES[1]}
                        component={Link}
                        to={PAGES[1]}
                      />
                      <Tab
                        sx={{ fontFamily: "sans-seriff" }}
                        onClick={refreshPage}
                        label="E-Books"
                        value={PAGES[2]}
                        component={Link}
                        to={PAGES[2]}
                      />
                      <Tab
                        sx={{ fontFamily: "sans-seriff" }}
                        onClick={refreshPage}
                        label="Coupons"
                        value={PAGES[3]}
                        component={Link}
                        to={PAGES[3]}
                      />
                      <Tab
                        sx={{ fontFamily: "sans-seriff" }}
                        onClick={refreshPage}
                        label="Subscribe"
                        value={PAGES[4]}
                        component={Link}
                        to={PAGES[4]}
                      />
                      <Tab
                        sx={{ fontFamily: "sans-seriff" }}
                        onClick={refreshPage}
                        label="Shop"
                        value={PAGES[5]}
                        component={Link}
                        to={PAGES[5]}
                      />
                      <Tab
                        sx={{ fontFamily: "sans-seriff" }}
                        onClick={refreshPage}
                        label="LiveClass"
                        value={PAGES[5]}
                        component={Link}
                        to={PAGES[6]}
                      />
                    </Tabs>
                    {/* 
                    <Button
                      sx={{ marginLeft: "auto", flexGrow: "0" }}
                      variant="contained"
                    >
                      Login
                    </Button>
                    <Button sx={{ marginLeft: "10px" }} variant="contained">
                      Sign-Up
                    </Button> */}
                  </>
                )}
              </Toolbar>
            </AppBar>
          )}
        />

        <Switch>
          <Route path="/home" component={Home} />
          <Route path="/courses" component={CoursesNavBar} />
          <Route path="/E-Books" component={EBooksNav} />
          <Route path="/coupons" component={Coupons} />
          <Route path="/Subscribe" component={ServicesOffered} />
          <Route path="/Shop" component={Shop} />
          <Route path="/LiveClassComponent" component={LiveClassComponent} />
          <Route path="/thankyoupage" component={ThankYouComponent} />
          <Route path="*" component={Home} />
        </Switch>
      </Router>
    </React.Fragment>
  );
};

export default Header;
